<template>
<content-div>
  <!-- 계기판, 자동차정기검사결과표 촬영 -->
  <step-bar :step="step" title="자동차정기검사결과표 촬영"></step-bar>

  <div class="contArea tpd">
    <!-- 구비서류 -->
    <div class="pictureArea">
      <!-- <img :src="`${$store.state.dir}images/license01.png`"> -->
      <div class="docuWrap">
        <div class="w45">
          <img :src="`${$store.state.dir}images/docu03.gif`">
          <!-- <h4>자동차정기검사<br>결과표</h4> -->
        </div>
        <div class="w45">
          <img :src="`${$store.state.dir}images/docu02.png`">
          <!-- <h4>계기판</h4> -->
        </div>
      </div>
      <p class="mgt1 alignL">자동차정기검사결과표의 검사 날짜는 <span class="fw400 fs16 colorRed">2년 이내</span>여야 하며, 해당 기간이 초과할 경우 서비스 해택이 불가할 수 있습니다.</p>
      <p class="mgt1 alignL">계기판은 차량에 시동을 거신 후 주행거리와 차량 경고등의 점등여부를 확인할 수 있도록 촬영해 주세요.</p>
      <p class="mgt1 alignL"><span v-html="$store.state.insuranceApplyNoti"></span></p>
      
    </div>

    <button-apply before="/subscApply/termInsurance" @submit="inspActivate = true; "></button-apply>
  </div>

  <popup-picture-ex 
    v-if="inspActivate"  
    :type="Const.SUBSC_ATT.INSP" 
    @close="inspClose">
  </popup-picture-ex>

  <!-- <popup-alert v-if="activate" title="주의사항" :btn_close="true" @close="closePopup">
    <popup-msg :type="popupMsg" @action="actionEmit"></popup-msg>
  </popup-alert>

  <popup-alert v-if="warnActivate" title="안내" @close="warnActivate=false">
    <p>주의사항 확인 체크 후 다음 단계로 진행이 가능합니다.</p>
  </popup-alert> -->

</content-div>
</template>


<script>
import Const from '../../../helpers/Const';
import ButtonApply from "@/components/Button/ButtonSubscApply.vue";
import PopupPictureEx from '@/components/Popup/PopupPictureEx.vue';
// import PopupAlert from '@/components/Popup/PopupAlert.vue';
// import PopupMsg from "@/components/Popup/PopupMsgTemplate";
import StepBar from '@/components/StepBar.vue';


  export default {
    beforeRouteEnter(to, from, next) {
      // if (
      //   from.name != 'SubscApplyTermInsurance' && // 구독 보험 약관 동의
      //   from.name != 'SubscApplyVehiclePanel'     // 구독 신청 계기판 촬영
      // ) {
      //   alert('잘못된 접근경로 입니다.');
      //   this.$store.commit("unsetTerms");
      //   next('/')
      // } else {
        next();
      // }
    },

    components: {
      ButtonApply,
      PopupPictureEx,
      //  PopupAlert,
      // PopupMsg,
      StepBar,
    },

    created() {
      this.step = Number(this.$route.query.step);
      window.scroll(0, 0);
    },

    data() {
      return {
        step:0,
        Const,
        inspActivate:false,

        // popupMsg: 'INSP_PANEL_PHOTO_WARNING',
        // activate: false,
        // warnActivate: false,
        // warnCheck: false,

        inspImgType: true,
        
      }
    },

    methods: {
      inspClose(bool){
        this.inspActivate = false;
        if(bool) this.callTakePictureAndUploadApi(2);  // 정기검사표 촬영 api 호출 method
        // if(bool) this.$router.push('/subscApply/vehiclePanel');

      },
      // app api response
      callbackRunTakePicture(value) {
        this.callbackRunTakePictureSubmit(value);
      }

      // inspClose(bool){
      //   this.inspActivate = false;
      //   if(bool) this.activate = true;
      // },

      // actionEmit(value) {
      //   this.warnCheck = value;
      // },

      // checkWarnAgree() {
      //   this.activate = false;
      //   if (!this.warnCheck) {
      //     this.warnActivate = true;
      //   } else {
      //     this.callTakePictureAndUploadApi(2);  // 정기검사표 촬영 api 호출 method
      //   }
      // },

      // closePopup(submit) {
      //   if (submit) {
      //     this.checkWarnAgree();
      //   } else {
      //     this.warnCheck = false;
      //     this.activate = false;
      //   }
      // },
    },
  }
</script>


<style lang="css" scoped>
</style>
